module.exports = __webpack_public_path__ + "img/ProjectPaw - Splash.95cbe96c.png";